// activityNewUser2
export default {
  routerTitle: '新客戶三重獎賞',
  giftPackage: '禮包',
  shareTitle: '新客戶三重獎賞，可享受高達3800港元大禮包！ ',
  shareDesc: '馬上入CASH的話再送你1500港元現金禮包！ ',

  cardOneTitle: '註冊就送88HKD禮包',
  cardOneText: '30天美股LV1行情券',

  cardTwoTitle: '開戶就送2256HKD禮包',
  cardTwoText1: '180天港股LV2',
  cardTwoText2: '180天美股LV1',

  cardThreeTitle: '入金2W最高贈送',
  cardThreeTabelTitle: '首筆入金≥2萬HKD',
  cardThreeTabelRow1Left1: '無要求',
  cardThreeTabelRow1Right1: '入金就送',
  cardThreeTabelRow1Right2: '300HKD',
  cardThreeTabelRow1Right3: '現金券',
  cardThreeTabelRow2Left1: '60天內無出金記錄',
  cardThreeTabelRow2Left2: '且60天內交易一次',
  cardThreeTabelRow2Right1: '滿足條件就送',
  cardThreeTabelRow2Right2: '500HKD',
  cardThreeTabelRow2Right3: '現金券',

  cardFourTitle: '入金20W最高贈送',
  cardFourTabelTitle: '首筆入金≥20萬HKD',
  cardFourTabelRow1Left1: '60天內無出金記錄',
  cardFourTabelRow1Left2: '且60天內交易一次',
  cardFourTabelRow1Right1: '滿足條件就送',
  cardFourTabelRow1Right2: '1500HKD',
  cardFourTabelRow1Right3: '現金券',

  pageTips: '注：首筆入金2W和首筆入金20W獎勵只能參與一個',
  receiveErr1: '交易1次且留存60天可再得500HKD哦！ ',
  receiveErr2: '不符合參加活動的條件',

  cardThreeTabelRow1Left1Cn: '30天內無出金紀錄',
  cardThreeTabelRow1Left2Cn: '且30天內交易一次',
  cardThreeTabelRow1Right1Cn: '滿足條件就送',
  cardThreeTabelRow1Right2Cn: '500HKD',
  cardThreeTabelRow1Right3Cn: '現金券',
  cardFourTitleCn: '入金30W最高贈送',
  cardFourTabelTitleCn: '首筆入金≥30萬HKD',
  cardFourTabelRow1Left1Cn: '30天內無出金紀錄',
  cardFourTabelRow1Left2Cn: '且30天內交易一次',
  cardFourTabelRow1Right1Cn: '滿足條件就送',
  cardFourTabelRow1Right2Cn: '1500HKD',
  cardFourTabelRow1Right3Cn: '現金券',
  pageTipsCn: '註：首筆入金2萬獎勵和首筆入金30萬獎勵只能參與一個'
}
